import React, { useEffect, useRef, useState } from 'react';
import Swal from 'sweetalert2';

export const Facturar = () => {
    const [cargando, setCargando] = useState(false);
    const [cargandoDatos, setCargandoDatos] = useState(false);
    const [enviando, setEnviando] = useState(false);

    const [cte,setCte] = useState(0);
    const [fol,setFol] = useState("");// "1-TK-23259620");
    const [cod,setCod] = useState(""); //ZMCNZNXCM");
    const [nom,setNom] = useState(""); //CESAR GUZMAN");
    const [rfc,setRfc] = useState(""); //XAXX010101000");
    const [dir,setDir] = useState(""); //MARGARITA 1448");
    const [pob,setPob] = useState(""); //LOS MOCHIS");
    const [cp,setCP] = useState(""); //81234");
    const [email,setEmail] = useState(""); //ceguzman@hotmail.com");
    const [reg,setReg] = useState("");
    const [uso,setUso] = useState("");

    const [fac,setFac] = useState("");
    const [pdf,setPdf] = useState("");
    const [xml,setXml] = useState("");

    const [usos, setUsos] = useState([]);
    const [regimenes, setRegimenes] = useState([]);

    //const urlBase = "http://localhost:16967";
    const urlBase = "https://www.arcocsl.com";

    const valido = cod != "" && fol != "" && nom != "" && rfc != "" && dir != "" && pob != "" && cp != "" && email != "" && reg != "" && uso != ""; 

    useEffect(() => {
        cargarCatalogos();
    },[]);

    const cargarCatalogos = async () => {
        let res = await fetch("https://www.facturar.isaerpweb.com/cfdi/listaUsos");
        const u = await res.json();
        res = await fetch("https://facturar.isaerpweb.com/home/wslistaRegimenes");
        const r = await res.json();
        setUsos(u);
        setRegimenes(r);
    }

    const generar = async() => {
        if(cargando)
            return;
        if(!valido){
            Swal.fire('Atencion','faltan datos para generar la factura','error');
            return;
        }
        if(rfc.length < 12){
            Swal.fire('Atencion','R.F.C. incompleto','error');
            return;
        }
        if(cp.length < 5){
            Swal.fire('Atencion','C.P. incompleto','error');
            return;
        }
        setCargando(true);

        const data = {
            emp: 1,
            usu: 0,
            cte : cte,
            folio:fol,
            nom:nom,
            dir:dir,
            pob:pob,
            token:cod,
            cp: cp,
            metodo: "PUE",
            forma: "01",
            uso:uso,
            rfc:rfc,
            regimen: reg,
            email:email
        };
        let url = urlBase + "/eCom/wsfacturarTK";
        let req = await fetch(url, {
            method: 'POST',
            body: JSON.stringify(data)
          })
        const resp = await req.json();
/*
    {
        "Status":"ok",
        "Numero":0,
        "Dato":{
            "Folio":"FA-386083",
            "linkPDF":"/ecom/pdf/1-TK-23258385-SXCCZRRCN",
            "linkXML":"/ecom/xml/1-TK-23258385-SXCCZRRCN"
        }
    }
*/

        if(resp.Status != "ok"){
           setXml("");
           setPdf("");
           setFac("");
           Swal.fire('Atencion',resp.Status,'error');
        }
        else{            
           setFac(resp.Dato.Folio);
           setPdf(urlBase + resp.Dato.linkPDF);
           setXml(urlBase + resp.Dato.linkXML);
        }
        setCargando(false);
    }

    const enviarEmail = async() => {
        const url = urlBase + "/eCom/enviarEmail?id=" + fol + "-" + cod + "&email=" + email;
        const req = await fetch(url, {
            method: 'POST' 
          });
        setEnviando(true);
        const res = await req.text();
        setEnviando(false);
        if(res.substring(0,5) === "Error"){
            Swal.fire('Atencion',res,'error');
            return res;
        }
        Swal.fire('Atencion','Se envio el email a ' + email,'success');
        return "ok";
    }
    const borrarDatos = () => {
        setCte(0);
        setFol("");
        setCod("");
        setNom("");
        setRfc("");
        setDir("");
        setPob("");
        setCP("");
        setEmail("");
        setReg("");
        setUso("");
        setFac("");
        setPdf("");
        setXml("");
    }
    const rfcBlur = async() => {
        setCte(0);
        if(rfc.length < 12)
            return;
        if(rfc == "XAXX010101000")
            return;
        let url = urlBase + "/eCom/facturasWebDatosCliente?id=" + rfc;
        setCargandoDatos(true);
        let resp = await fetch(url);
        setCargandoDatos(false);
        let data = await resp.json();
        if (data.alm != 0) {
            setCte(data.cte);
            setNom(data.nom);
            setDir(data.dir);
            setPob(data.pob);
            setCP(data.cp);
            setEmail(data.email);
            setReg(data.regimen);
            setUso(data.uso);
        }
    }
    return (
        <div style={{ backgroundColor: 'white', height: 10000 }}>
            <div style={{ textAlign: 'center' }}>
                <h4 style={{ color: 'darkgreen' }}>Eléctrica y plomería EL ARCO</h4>
                <img src="/fondoarco.png" alt="El Arco CSL" />
                <h6>Facturar Tiket</h6>
            </div>
            <div className='row'>
                <div className='col-1'></div>
                <div className='col-3'>
                    <div className="card">
                        <div class="card-header" style={{color:'white',backgroundColor:'#144015'}}>
                            <h6>Datos del tiket</h6>
                        </div>
                        <div className="card-body">
                            <table>
                                <tr>
                                    <td>Folio</td>
                                    <td><input value={fol} onChange={e => setFol(e.target.value)} className='form-control form-control-sm' style={{ width: 200 }} /></td>
                                </tr>
                                <tr>
                                    <td>Codigo</td>
                                    <td><input value={cod} onChange={e => setCod(e.target.value)} className='form-control form-control-sm' style={{ width: 200 }} /></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        <button disabled={cargando} onClick={borrarDatos} className='btn btn-sm btn-outline-secondary'>
                                            <span>borrar datos</span>
                                        </button>
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>

                <div className='col-5'>
                    <div className="card">
                        <div class="card-header"  style={{color:'white',backgroundColor:'#144015'}}>
                            <h6>Datos del cliente - No de cliente : {cte}</h6>
                        </div>
                        <div className="card-body">
                            <table>
                                <tr>
                                    <td>R.F.C.</td>
                                    <td><input onBlur={rfcBlur} value={rfc} onChange={e => setRfc(e.target.value)} className='form-control form-control-sm' style={{ width: 150 }} /></td>
                                    <td style={{width:40}}>{cargandoDatos && <div className="spinner-border spinner-border-sm" role="status"/>}</td>
                                </tr>
                                <tr>
                                    <td>Nombre</td>
                                    <td><input value={nom} onChange={e => setNom(e.target.value)} className='form-control form-control-sm' style={{ width: 400 }} /></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Direccion</td>
                                    <td><input value={dir} onChange={e => setDir(e.target.value)} className='form-control form-control-sm' style={{ width: 500 }} /></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Poblacion</td>
                                    <td><input value={pob} onChange={e => setPob(e.target.value)} className='form-control form-control-sm' style={{ width: 300 }} /></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>C.P.</td>
                                    <td><input value={cp} onChange={e => setCP(e.target.value)} className='form-control form-control-sm' style={{ width: 70 }} /></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Email</td>
                                    <td><input value={email} onChange={e => setEmail(e.target.value)} className='form-control form-control-sm' style={{ width: 400 }} /></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Regimen</td>
                                    <td>
                                        <select className="form-select form-select-sm" value={reg} onChange={e => setReg(e.target.value)} style={{ width: 500 }}>
                                            <option value={""}>Especifique</option>
                                            {regimenes.map((i, k) =>
                                                <option key={i.Id} value={i.Id}>{i.Dato1}</option>
                                            )}
                                        </select>
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Uso</td>
                                    <td>
                                        <select className="form-select form-select-sm" value={uso} onChange={e => setUso(e.target.value)} style={{ width: 500 }}>
                                            <option value={""}>Especifique</option>
                                            {usos.map((i, k) =>
                                                <option key={i.Id} value={i.Id}>{i.Dato1}</option>
                                            )}
                                        </select>
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        <button disabled={cargando || !valido} onClick={generar} className='btn btn-sm btn-outline-secondary'>
                                            <span>generar factura</span>
                                            {cargando ? <div className="spinner-border spinner-border-sm" role="status"/> : <></>}
                                        </button>
                                    </td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td></td>
                                    <td>
                                        {fac !== "" &&
                                            <table>
                                                <tr>
                                                    <td><span>Factura : <b>{fac}</b>&nbsp;&nbsp;&nbsp;</span></td>
                                                    <td>
                                                        <button disabled={enviando} onClick={enviarEmail} className='btn btn-sm btn-outline-secondary'>
                                                            <span>enviar por email</span>
                                                            {enviando ? <div className="spinner-border spinner-border-sm" role="status" /> : <></>}
                                                        </button>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <a href={xml} target="_blank">Descargar XML</a><br />
                                                        <a href={pdf} target="_blank">Descargar PDF</a><br />
                                                    </td>
                                                    <td>
                                                    </td>
                                                </tr>
                                            </table>
                                        }
                                    </td>
                                    <td></td>
                                </tr>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}